module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages"
  }, [_c('section', {
    staticClass: "fx filter-list"
  }, [_c('div', {
    staticClass: "fx fx-wrap fx-fill"
  }, [_c('z-select', {
    staticClass: "w150",
    attrs: {
      "options": _vm.statusItems
    },
    on: {
      "handleChange": function($event) {
        return _vm.handleOffset(0)
      }
    },
    model: {
      value: (_vm.params.status),
      callback: function($$v) {
        _vm.$set(_vm.params, "status", $$v)
      },
      expression: "params.status"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fx fx-wrap fx-fill"
  }), _vm._v(" "), _c('z-search', {
    attrs: {
      "placeholder": "请输入微信昵称"
    },
    on: {
      "handleSearch": function($event) {
        return _vm.handleOffset(0)
      }
    },
    model: {
      value: (_vm.params.search),
      callback: function($$v) {
        _vm.$set(_vm.params, "search", $$v)
      },
      expression: "params.search"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "list"
    }
  }, [_c('z-table', {
    attrs: {
      "offset": _vm.params.offset,
      "count": _vm.params.count,
      "total-count": _vm.recordList.item_total
    },
    on: {
      "handleOffset": _vm.handleOffset
    }
  }, [_vm._l((_vm.columns), function(index, item) {
    return _c('th', {
      attrs: {
        "slot": "columns"
      },
      slot: "columns"
    }, [_vm._v("\n\t\t\t\t" + _vm._s(index) + "\n\t\t\t")])
  }), _vm._v(" "), _vm._l((_vm.recordList.list || []), function(item) {
    return _c('tr', {
      attrs: {
        "slot": "datasource"
      },
      slot: "datasource"
    }, [_c('td', [_vm._v(_vm._s(item.nickname))]), _vm._v(" "), _c('td', [_c('img', {
      attrs: {
        "src": item.headimgurl
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("filterMoney")(item.total_fee)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("filterMoney")(item.pay_fee)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("filterMoney")(item.envelope_fee)))]), _vm._v(" "), _c('td', [(item.status == 1) ? _c('span', [_vm._v("已领取")]) : _c('span', [_vm._v("已使用")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("momentFmt")(item.l_time)))])])
  })], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-5bf31bb2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/marketing/red_packet/RedPacketRecordPage.vue
// module id = 853
// module chunks = 0